module.exports = __webpack_public_path__ + "static/media/allergies.3e04ee99.svg";